import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Building, MapPin, Calendar, CheckCircle } from 'lucide-react';

const Experience = ({ data }) => {
  return (
    <section id="experience" className="py-20 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Professional Experience
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            My journey through cybersecurity and software development roles
          </p>
        </div>

        <div className="space-y-8">
          {data.map((experience, index) => (
            <Card 
              key={index} 
              className="bg-slate-700/30 border-slate-600 hover:bg-slate-700/50 transition-all duration-300 group"
            >
              <CardHeader className="pb-4">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                  <div>
                    <CardTitle className="text-2xl font-bold text-white group-hover:text-emerald-400 transition-colors duration-200">
                      {experience.position}
                    </CardTitle>
                    <div className="flex flex-wrap items-center gap-4 mt-2">
                      <div className="flex items-center text-slate-300">
                        <Building className="h-4 w-4 mr-2 text-emerald-400" />
                        {experience.company}
                      </div>
                      <div className="flex items-center text-slate-300">
                        <MapPin className="h-4 w-4 mr-2 text-blue-400" />
                        {experience.type}
                      </div>
                    </div>
                  </div>
                  <Badge 
                    variant="outline" 
                    className="border-emerald-400 text-emerald-400 hover:bg-emerald-400 hover:text-slate-900 transition-all duration-200"
                  >
                    <Calendar className="h-3 w-3 mr-1" />
                    {experience.duration}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                <p className="text-slate-300 text-lg leading-relaxed">
                  {experience.description}
                </p>
                
                <div className="space-y-3">
                  <h4 className="text-lg font-semibold text-white">Key Achievements:</h4>
                  <div className="grid gap-3">
                    {experience.achievements.map((achievement, achievementIndex) => (
                      <div key={achievementIndex} className="flex items-start space-x-3 group/achievement">
                        <CheckCircle className="h-5 w-5 text-emerald-400 mt-0.5 flex-shrink-0 group-hover/achievement:scale-110 transition-transform duration-200" />
                        <p className="text-slate-300 group-hover/achievement:text-white transition-colors duration-200">
                          {achievement}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Timeline Connector */}
        <div className="relative mt-12">
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-24 bg-gradient-to-b from-emerald-400 to-blue-500 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Experience;